import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row, Col} from 'antd';
import '../resourcePool.css'

export default class Video extends Component {
    static defaultProps = {
        checked: false,
        title: 'fdfdfdfdfdfdfdfdfdfssssssss',
        type: 'list',
        createTime: '2020-12-22 16:10:11',
        img:'/storage/61892881C53EB8C2290DAE038B997B28/thumbnails/1',
        singleClick: () => {

        },
        doubleClick: () => {

        }
    };
    static propTypes = {
        title: PropTypes.string.isRequired,//传入dom 结构
        type: PropTypes.string.isRequired,//small  middle, big ,list
        checked: PropTypes.bool,//是否选中
        singleClick: PropTypes.func.isRequired,//单击回调函数
        doubleClick: PropTypes.func.isRequired,//双击函数
        img: PropTypes.string.isRequired,//传入图片

    };

    constructor(props) {
        super(props);
        this.state = {
            hover: false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    handleEnter() {
        this.setState({hover: true})
    }

    handleOut() {
        this.setState({hover: false})
    }

    render() {
        // 鼠标点击划过  公共
        let backgroundColor

        if (this.props.checked) {
            backgroundColor = '#b5d1f4'
        } else {
            backgroundColor = '#ffffff';
            if (this.state.hover) {
                backgroundColor = '#f1f5fa';
            } else {
                backgroundColor = 'white';
            }
        }
        return (
            <div style={{cursor: 'pointer'}} onClick={() => {
                this.props.singleClick && this.props.singleClick()
            }} onDoubleClick={() => {
                this.props.doubleClick && this.props.doubleClick()
            }}>
                {this.props.type === 'list' ? this.renderFileList(backgroundColor) : this.renderFileCard(backgroundColor)}
            </div>)

    }

    //渲染小 中，大
    renderFileCard(backgroundColor) {
        let width, height, picW, picH, fontsize;
        if (this.props.type === 'small') {
            width = 140;
            height = 140;
            picW = 56;
            picH = 56;
        } else if (this.props.type === 'middle') {
            width = 200;
            height = 200;
            picW = 100;
            picH = 100;
            fontsize = 18;
        } else if (this.props.type === 'big') {
            width = 300;
            height = 300;
            picW = 150;
            picH = 150;
            fontsize = 25
        }
        return (
            <div style={{
                width: width,
                height: height,
                textAlign: 'center',
                paddingTop: 11,
                background: backgroundColor,
                borderRadius: '16px',
                margin: '9px 18px 0',
                float: 'left'
            }}
                 onMouseEnter={() => this.handleEnter()}
                 onMouseLeave={() => this.handleOut()}
            >
                <div style={{position: 'relative', width: picW, height: picH, margin: '0 auto'}}>
                    <img src={this.props.img} style={{width: picW, height: picH, objectFit: 'cover'}}/>
                    <img src='images/play.png' style={{
                        width: '26px',
                        height: '26px',
                        objectFit: 'cover',
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        marginTop: '-13px',
                        marginLeft: '-13px'
                    }}/>
                </div>
                <div title={this.props.title}  className={'theretext'}
                     style={{fontSize: fontsize, overflow: 'hidden', textOverflow: 'ellipsis'}}>{this.props.title}</div>
            </div>
        )
    }

    //渲染列表
    renderFileList(backgroundColor) {
        return (
            <div style={{padding: '8px'}}>
                <Row style={{lineHeight: '50px', height: '50px', background: backgroundColor, borderRadius: '8px',clear: 'both'}}
                     onMouseEnter={() => this.handleEnter()}
                     onMouseLeave={() => this.handleOut()}>
                    <Col span={8} style={{paddingLeft: '15px'}}>
                        <div style={{display: 'flex'}}>
                            <div style={{position: 'relative', width: '40px', height: '40px'}}>
                                <img src={this.props.img} style={{width: '40px', height: '40px', objectFit: 'cover',}}/>
                                <img src='images/play.png' style={{
                                    width: '26px',
                                    height: '26px',
                                    objectFit: 'cover',
                                    position: 'absolute',
                                    left: '50%',
                                    top: '50%',
                                    marginTop: '-8px',
                                    marginLeft: '-13px'
                                }}/>
                            </div>
                            <div style={{
                                paddingLeft: '15px',
                                width: '200px',
                                height: '50px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }} title={this.props.title}>{this.props.title}</div>
                        </div>
                    </Col>
                    <Col span={8}>创建时间: {this.props.createTime}</Col>
                    <Col span={8}>视频</Col>
                </Row>
            </div>)
    }
}